import { render, staticRenderFns } from "./SysCheckRuleModal.vue?vue&type=template&id=3f940986&scoped=true&"
import script from "./SysCheckRuleModal.vue?vue&type=script&lang=js&"
export * from "./SysCheckRuleModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f940986",
  null
  
)

export default component.exports